import React, { Component, useEffect, useState, useRef } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import _ from "lodash"
import moment from "moment"
import Title from "../general/title"
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"
import ReactSelect from "components/ReactSelect"
import submitData from "helpers/submitData"
import numeral from 'numeral'

function LotSalesStatus(props) {
	const [ready, setReady] = useState(false)
	const [data, setData] = useState({})
	const [opts, setOpts] = useState({ builder: 0, lot_type: 0, section_id: 0 })
	const [rows, setRows] = useState([])
	const [quick, setQuick] = useState({})

	//? The total number is based on the contracts loaded into lot_sales_status whereas the sold number is what we have on file right now with takedown dates.

	useEffect(() => {
		lookupData(opts)
		if (!opts.builder && !opts.lot_type && !opts.section_id) setReady(false)
	}, [opts])

	useEffect(() => {
		calcQuick()
		//
	}, [data])

	const options = (name) => {
		let ret = []
		props.payload.public[name].forEach((v) => {
			if (props.activeProperties[0] == v.property) {
				ret.push({ label: v.name, value: v.id })
			}
		})

		ret = _.sortBy(ret, "label")
		return ret
	}

	const optionsAlpha = (name) => {
		let opts = _.map(props.payload.public[name], (v) => {
			return { label: v.name, value: v.id }
		})
		opts = _.sortBy(opts, "label")
		return opts
	}

	const lookupData = async () => {
		if (opts.builder || opts.lot_type || opts.section_id) {
			opts.property = props.activeProperties[0]
			let lookup = {
				builder: opts.builder,
				property: props.activeProperties[0],
				lot_type: opts.lot_type,
				section_id: opts.section_id,
				multi: true,
			}

			props.loadingStatus(true)
			submitData("lotSalesStatusLookup", lookup)
				.then((resp) => {
					setData(resp.data)
					props.loadingStatus(false)
					if (lookup.builder && lookup.lot_type && lookup.section_id && resp.data) {
						buildTable()
					} else setRows([])

					setReady(true)
				})
				.catch((e) => {
					console.error(e)
					props.loadingStatus(false)
					setRows([])
					setReady(false)
				})
		}
	}

	const calcQuick = () => {
		let f = {
			total: 0,
			sold: 0,
			ytd: 0
		}
		_.forEach(props.payload.exec.lots, (v) => {
			if (
				v.property !== props.activeProperties[0] ||
				(opts.builder && v.builder !== opts.builder) ||
				(opts.lot_type && v.lot_type !== opts.lot_type) ||
				(opts.section_id && v.section_id !== opts.section_id)
			)
				return
			if (v.takedown_date) {
				f.sold++
			}
		})

		// Now find the contracted totals from data
		_.forEach(data, (v) => {
			_.forEach(v.data, (r) => {
				f.total += r
			})
		})

		// Figure out current YTD
		let start = moment().startOf('year').unix()
		let end = moment().endOf('month').unix()
		let ytd = 0
		let months = helpers.monthsBetween(start, end)
		let store = betweenDates(months)
		_.forEach(store, v => {
			ytd -= v.contracts
			ytd += v.takedowns
		})
		f.ytd = ytd > 0 ? `+${ytd}` : ytd

		// Now figure out ahead/behind
		// Determine oldest start date
		let aheadBehind = 0
		start = null
		_.forEach(data, v => {
			if(!start || v.start < start) start = v.start
		})
		months = helpers.monthsBetween(start, moment().unix())
		store = betweenDates(months)
		_.forEach(store, (v) => {
			aheadBehind -= v.contracts
			aheadBehind += v.takedowns
		})
		f.aheadBehind = aheadBehind

		setQuick(f)
	}

	const betweenDates = months => {
		let store = {}
		
		// This area can be simplified, but kept it with the store to make it easier to debug.
		_.forEach(months, (v) => {
			let path = `${v.month}-${v.yearShort}`
			let mom = moment(path, "MMM-YY")
			let start = mom.startOf("month").unix()
			let end = mom.endOf("month").unix()
			store[path] = {
				contracts: 0,
				takedowns: 0,
			}
			_.forEach(data, (d) => {
				let val = _.get(d, `data.${path}`)
				if (val) store[path].contracts += val
			})
			store[path].takedowns = takedownsInMonth(start, end)
		})

		return store
	}

	const takedownsInMonth = (start, end) => {
		let filteredLots = _.filter(props.payload.exec.lots, (v) => {
			if (!v.takedown_date) return false
			if(opts.builder && v.builder !== opts.builder) return false
			if(opts.lot_type && v.lot_type !== opts.lot_type) return false
			if(opts.section_id && v.section_id !== opts.section_id) return false
			
			if(v.takedown_date >= start && v.takedown_date <= end) return true
		})

		return filteredLots.length
	}

	const buildTable = () => {
		let rows = []
		let d = {}
		let contracts = data[0]
		let curYear = moment.unix(contracts.start).year()
		let cur = 0
		let ab = 0
		if (contracts && contracts.start && contracts.end) {
			let months = helpers.monthsBetween(contracts.start, contracts.end)
			_.forEach(months, (v, k) => {
				let path = `${v.month}-${v.yearShort}`
				let mom = moment(path, "MMM-YY")
				let start = mom.startOf("month").unix()
				let end = mom.endOf("month").unix()
				let con = _.get(contracts, `data[${path}]`) || 0
				if (curYear !== v.year) {
					curYear = v.year
					cur = 0
				}
				let filteredLots = _.filter(props.payload.exec.lots, (v) => {
					if (
						v.builder == opts.builder &&
						v.lot_type == opts.lot_type &&
						v.section_id == opts.section_id &&
						v.takedown_date &&
						v.takedown_date >= start &&
						v.takedown_date <= end
					)
						return true
				})
				cur += filteredLots.length
				cur -= con
				ab += filteredLots.length
				ab -= con
				
				// If in future, null out ab
				if(moment().endOf('month').unix() < end) ab = ""
				let diff = filteredLots.length - con
				rows.push({
					year: v.yearShort,
					month: v.fullMonth,
					contracted: con ? con : "",
					taken: filteredLots.length || "",
					monthly: diff ? diff : "",
					ytd: cur,
					ab
				})
			})
		}
		setRows(rows)
	}

	let columns = [
		{
			Header: "Month",
			accessor: "month",
			filterMethod: (f, r) => helpers.tableText(f, r, "month"),
		},
		{
			Header: "Year",
			accessor: "year",
			filterMethod: (f, r) => helpers.tableText(f, r, "year"),
		},
		{
			Header: "Contracted",
			accessor: "contracted",
			filterMethod: (f, r) => helpers.tableText(f, r, "contracted"),
		},
		{
			Header: "Taken Down",
			accessor: "taken",
			filterMethod: (f, r) => helpers.tableText(f, r, "taken"),
		},
		{
			Header: "Monthly Variance",
			accessor: "monthly",
			filterMethod: (f, r) => helpers.tableText(f, r, "monthly"),
			Cell: (v) => {
				if (v.value) {
					if (Math.sign(v.value) == 1) {
						return <span className="darkGreen bold">+{v.value}</span>
					} else if (Math.sign(v.value) == -1) {
						return <span className="red bold">{v.value}</span>
					}
				}
				return ""
			},
		},
		{
			Header: "YTD Variance",
			accessor: "ytd",
			filterMethod: (f, r) => helpers.tableText(f, r, "ytd"),
			Cell: (v) => {
				if (v.value) {
					if (Math.sign(v.value) == 1) {
						return <span className="darkGreen bold">+{v.value}</span>
					} else if (Math.sign(v.value) == -1) {
						return <span className="red bold">{v.value}</span>
					}
				}
				return ""
			},
		},
		{
			Header: "Ahead/Behind",
			accessor: "ab",
			filterMethod: (f, r) => helpers.tableText(f, r, "ab"),
			Cell: (v) => {
				if (v.value) {
					if (Math.sign(v.value) == 1) {
						return <span className="darkGreen bold">+{v.value}</span>
					} else if (Math.sign(v.value) == -1) {
						return <span className="red bold">{v.value}</span>
					}
				}
				return ""
			},
		},
	]

	if (props.activeProperties.length !== 1) {
		return (
			<div className="pleaseChoose">
				<h1>Please choose one community to view.</h1>
			</div>
		)
	} else if (props.payloadStatus) {
		return (
			<div>
				<div className="imageGroup">
					<Title title="Lot Sales Status" showDate={false} />
					<div className="content">
						<div className="z-[200] relative">
							<div className="reportGroup">
								<h3>Data Set</h3>
								<ul className="form__list">
									<li className="form__listItem">
										<label htmlFor="builder">Builder</label>
										<ReactSelect
											name={`builder`}
											options={optionsAlpha("builders")}
											value={opts.builder}
											onBlur={() => {}}
											clearable={true}
											onChange={(field, v) => {
												let o = _.clone(opts)
												o.builder = v
												setOpts(o)
											}}
										/>
									</li>
									<li className="form__listItem">
										<label htmlFor="section_id">Section</label>
										<ReactSelect
											name={`section_id`}
											options={options("sections")}
											value={opts.section_id}
											onBlur={() => {}}
											clearable={true}
											onChange={(field, v) => {
												let o = _.clone(opts)
												o.section_id = v
												setOpts(o)
											}}
										/>
									</li>
									<li className="form__listItem">
										<label htmlFor="lot_type">Lot Type</label>
										<ReactSelect
											name={`lot_type`}
											options={options("lot_types")}
											value={opts.lot_type}
											onBlur={() => {}}
											clearable={true}
											onChange={(field, v) => {
												let o = _.clone(opts)
												o.lot_type = v
												setOpts(o)
											}}
										/>
									</li>
								</ul>
							</div>
						</div>
						{ready ? (
							<>
								<div className="quickStats">
									<ul className="quickStats__list">
										<li className="quickStats__item">
											<div>
												<div className="quickStats__stat">{quick.total}</div>
												<div className="quickStats__type">Contracted Lots</div>
											</div>
										</li>
										<li className="quickStats__item">
											<div>
												<div className="quickStats__stat">{quick.sold}</div>
												<div className="quickStats__type">Lot Takedowns</div>
											</div>
										</li>
										<li className="quickStats__item">
											<div>
												<div className="quickStats__stat">{quick.total - quick.sold}</div>
												<div className="quickStats__type">Remaining</div>
											</div>
										</li>
										<li className="quickStats__item">
											<div>
												<div className="quickStats__stat">{quick.aheadBehind}</div>
												<div className="quickStats__type">Ahead/Behind</div>
											</div>
										</li>
										{/* <li className="quickStats__item">
											<div>
												<div className="quickStats__stat">{quick.ytd}</div>
												<div className="quickStats__type">YTD Status</div>
											</div>
										</li> */}
									</ul>
								</div>
								{rows.length > 0 && (
									<>
										<h2>Contract Information</h2>
										{data[0] && data[0].base_price && (
											<p>Base Pricing: {numeral(data[0].base_price).format("$0,0")}</p>
										)}
										{data[0] && data[0].notes && (<><h3>Notes</h3><p>{data[0].notes}</p></>)}
										<h2>Detailed Schedule</h2>
										<FullTable
											data={rows}
											columns={columns}
											name="lotSalesStatus__detail"
											title="Lot Sales Status"
											sortable={false}
											pageSize={30}
										/>
									</>
								)}
							</>
						) : (
							<p style={{ textAlign: "center", color: "#999" }}>No entries exist for this data type.</p>
						)}
					</div>
				</div>
			</div>
		)
	}
	return ""
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(LotSalesStatus)
